import React from 'react';
import { View, ActivityIndicator, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import fonts from 'app/src/styles/fonts';

const CONTAINER_STYLES = `
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  background-color: ${colors.button};
  width: 200px;
  padding: 6px;
  border-radius: 6px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Container = styled(View)`
  ${CONTAINER_STYLES}
`;

const PressableContainer = styled(Pressable)`
  ${CONTAINER_STYLES}
  background-color: ${props => props.disabled ? 'gray' : colors.button};
`;

const ButtonText = styled(Text)`
  font-family: '${fonts.body}';
  font-size: 18px;
  color: white;
  font-weight: 800;
  text-decoration-line: none;
  text-align: center;
`;

export const ButtonGroup = styled(View)`
  flex-direction: row;
  gap: 8px;
`;

export const Button = allProps => {
  const { to, label, dangerous, inline, wide, processing, ...props } = allProps;

  props.style ||= {};
  const textStyle = {};

  if ('Cancel' === props.type) {
    props.style.backgroundColor ||= '#505050';
    label ||= 'Cancel';
  } else if (dangerous) {
    props.style.backgroundColor ||= colors.danger;
  }

  if (inline) {
    props.style.marginTop = 0;
    props.style.maringBottom = 0;
    textStyle.fontSize = 14;
  }

  if (wide) {
    props.style.width = '100%';
  }

  if (processing) {
    props.disabled = true;
  }

  const content = (
    <>
      <ButtonText style={textStyle}>{label}</ButtonText>
      {processing && <ActivityIndicator size="small" color="lightgray" />}
    </>
  );

  return <PressableContainer {...props}>{content}</PressableContainer>;

  return content;
}
